import { useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { AddInternshipForm } from "../Forms/AddInternshipForm";

export const AddInternshipFormPage = (props: { location: any }) => {
	const [redirect, setRedirect] = useState(false);
	const { internshipId } = useParams<{
		internshipId?: string;
	}>();

	if (redirect) {
		// Return to the exact list URL (filters, tab and page live in the query string)
		const returnUrl: string | undefined = props.location.state?.returnUrl;
		if (returnUrl) {
			return <Redirect to={returnUrl} />;
		}

		return (
			<Redirect
				to={{
					pathname: "/propuneri",
					state: {
						existingFilters: props.location.state?.filters,
						searchTerm: props.location.state?.searchTerm,
						sortField: props.location.state?.sortField,
						sortDirection: props.location.state?.sortDirection,
						currentPage: props.location.state?.currentPage,
						pageSize: props.location.state?.pageSize,
						activeTab: props.location.state?.activeTab,
					},
				}}
			/>
		);
	} else {
		return (
			<AddInternshipForm
				location={props.location}
				setRedirect={setRedirect}
				internshipId={internshipId}
				type={props.location.state?.type}
				isDuplicating={props.location.state?.isDuplicating}
			/>
		);
	}
};
